
  import '/home/ec2-user/Youlify-Design/components/date-picker/index.$tab-design.zh-CN.md?watch=parent';
  export const texts = [{"value":"DatePicker 的本质是选择（输入）日期型数据。","paraId":0,"tocIndex":0}];
  